export default {
  billing: {
    subscription: {
      default: {
        title: "Custom",
        name: "Custom",
        description: {
          long: "With a custom subscription, you have the freedom to choose the features and services that matter most to you, and only pay for what you need.",
          short: "tailored to your unique needs and preferences.",
        },
      },
      free: {
        title: `Free`,
        name: `Free`,
        description: {
          long: `Lorem ipsum, dolor sit amet consectetur adipisicing elit. Deserunt at dolorem rem nisi impedit dolorum quisquam adipisci fugiat dignissimos numquam! Assumenda, odit. Ipsa, aut quibusdam.`,
          short: `Lorem ipsum, dolor sit amet consectetur adipisicing elit.`,
        },
      },
      basic: {
        title: `Basic`,
        name: `Basic`,
        description: {
          long: `Lorem ipsum, dolor sit amet consectetur adipisicing elit. Deserunt at dolorem rem nisi impedit dolorum quisquam adipisci fugiat dignissimos numquam! Assumenda, odit. Ipsa, aut quibusdam.`,
          short: `Lorem ipsum, dolor sit amet consectetur adipisicing elit.`,
        },
      },
      enterprise: {
        title: `Enterprise`,
        name: `Enterprise`,
        description: {
          long: `Lorem ipsum, dolor sit amet consectetur adipisicing elit. Deserunt at dolorem rem nisi impedit dolorum quisquam adipisci fugiat dignissimos numquam! Assumenda, odit. Ipsa, aut quibusdam.`,
          short: `Lorem ipsum, dolor sit amet consectetur adipisicing elit.`,
        },
      },
    },
  },

  permissions: {
    teams: {
      name: `Teams`,
      description: `Manage (create, update, archive, delete) Teams`,
    },
    subscriptions: {
      name: `Subscriptions`,
      description: `View Subscriptions Page, Switch Subscriptions, Manage Subscription Overage Limits`,
    },
    invitations: {
      name: `Invitations`,
      description: `Manages (send, resend) Team Invitations`,
    },
    members: {
      name: `Members`,
      description: `Manage (update, archive, delete) Team Members`,
    },
    domains: {
      name: `Domain`,
      description: `Manage (view and select) Organization and Team Domains`,
    },
    profile: {
      name: `Profile`,
      description: `Update Organization Profile`,
    },
    users: {
      name: `Users`,
      description: `Manage (invite, block, delete) Organization Users`,
    },
    roles: {
      name: `Roles`,
      description: `Manage (create, update, delete) Organization Roles`,
    },
    supervisor: {
      name: `Supervisor`,
      description: `Access Team Member, Create TinyURLs within a Team`,
    },
    s_s_o: {
      name: `SSO`,
      description: `Manage SSO Settings`,
    },
    audit: {
      name: `Audit`,
      description: `Manage Audit Logs`,
    },
  },
};
